import getConfig from 'next/config'

import { GoogleMapsSettings, MarkerClusters, Pin } from '@grandvisionhq/common'

const { publicRuntimeConfig } = getConfig()
const gmKey = publicRuntimeConfig.googleMaps.apiKey ?? ''
const gmCenter = publicRuntimeConfig.googleMaps.mapCenter ?? {}

export const getGoogleMapsConfig = (): GoogleMapsSettings => ({
  apiKey: gmKey,
  defaultCenter: gmCenter,
  defaultZoom: 6,
  pin: Pin({
    themes: {
      primary: { foreground: '#ffffff', background: '#000000' },
      highlight: { foreground: '#ffffff', background: '#C2C3C3' },
      hovered: { foreground: '#707070', background: '#ffffff' },
    },
  }),
  markerClusterOptions: MarkerClusters({
    theme: {
      color: '#000000',
      textColor: '#ffffff',
    },
    minimumClusterSize: 3,
    maxZoom: 10,
  }),
})
